import { render, staticRenderFns } from "./edit-banner-branding.vue?vue&type=template&id=0505d680&scoped=true&"
import script from "./edit-banner-branding.vue?vue&type=script&lang=js&"
export * from "./edit-banner-branding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505d680",
  null
  
)

export default component.exports